function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useMemo, useState } from 'react';
import './FilterCheckboxesInput.css';
import Fieldset from '../Fieldset/Fieldset';
import withInputContainer from '../withInputContainer/withInputContainer';
import { Checkbox, CheckboxesInput } from '../CheckboxesInput/CheckboxesInput';
import { TextInput } from '../TextInput/TextInput';
import uuid from '../../utils/uuid';
function toLowerCaseString(value) {
  return typeof value === 'string' ? value.toLowerCase().trim() : '';
}
var SELECT_ALL_OPTION = {
  label: '@dm/components.select-all'
};
export function FilterCheckboxesInput(props) {
  var onChange = props.onChange,
    options = props.options,
    scroll = props.scroll,
    _props$selectAll = props.selectAll,
    selectAll = _props$selectAll === void 0 ? false : _props$selectAll,
    value = props.value;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    filter = _useState2[0],
    setFilter = _useState2[1];
  var handleFilter = useCallback(function (event) {
    return setFilter(event.target.value);
  }, []);
  var _useMemo = useMemo(function () {
      var lowerCaseFilter = toLowerCaseString(filter);
      var filteredOptions = lowerCaseFilter && lowerCaseFilter.length > 0 ? options.filter(function (option) {
        return toLowerCaseString(option.label).indexOf(lowerCaseFilter) !== -1;
      }) : options;
      return [value, filteredOptions];
    }, [value, options, filter]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    filteredValue = _useMemo2[0],
    filteredOptions = _useMemo2[1];
  var selectAllId = useMemo(function () {
    return uuid();
  }, []);
  var selectAllChecked = options.length === value.length;
  var handleSelectAll = useCallback(function () {
    onChange(selectAllChecked ? [] : options.map(function (option) {
      return option.value;
    }));
  }, [onChange, selectAllChecked, options]);
  return /*#__PURE__*/React.createElement("div", {
    className: "_dm-filter-checkboxes"
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: filter,
    onChange: handleFilter
  }), selectAll && /*#__PURE__*/React.createElement("div", {
    className: "_dm-filter-checkboxes__select-all ".concat(scroll ? '_dm-filter-checkboxes__select-all--scroll' : '')
  }, /*#__PURE__*/React.createElement(Checkbox, Object.assign({}, props, {
    checked: selectAllChecked,
    id: selectAllId,
    name: "select-all-".concat(selectAllId),
    onChange: handleSelectAll,
    option: SELECT_ALL_OPTION
  }))), /*#__PURE__*/React.createElement(CheckboxesInput, Object.assign({}, props, {
    value: filteredValue,
    options: filteredOptions
  })));
}
export default withInputContainer({
  type: 'checkboxes',
  element: Fieldset
})(FilterCheckboxesInput);